/**
 * Append alpha to a hex color string.
 * alpha: 0–100 (percentage)
 * colorAlpha('#00F0FF', 25) → '#00F0FF40'
 */
export function colorAlpha(hex: string, alpha: number): string {
  const a = Math.round((alpha / 100) * 255)
    .toString(16)
    .padStart(2, "0");
  return `${hex}${a}`;
}

/**
 * Merge class names, filtering out falsy values.
 */
export function cn(...classes: (string | undefined | null | false)[]): string {
  return classes.filter(Boolean).join(" ");
}
